import { combineReducers } from "redux";
import { createUserReducer, loginUserReducer, getOTpReducer, verifyOtpReducer, logoutUserReducer, fetchHospitalPaymentConfigReducer, fetchConsultationCostsReducer } from "./userReducers";
import { bookAppontmentReducer, getAppointmentReducer, getClinicsReducer, getDoctorsReducer } from "./appointmentReducer";
import { createPasswordReducer } from "./createPasswordReducer";
import { createPaymentReducer, getRecentPaymentsReducer } from "./payment";
import { checkAppointment } from "./checkAppointment";
import { phoneLookupReducer, virtualQrPaymentReducer, virtualQrVerifyReducer } from "./phoneLookupReducers";

const rootReducer = combineReducers({
  createUser: createUserReducer,
  loginUser: loginUserReducer,
  bookAppontment: bookAppontmentReducer,
  createPassword: createPasswordReducer,
  getOtp: getOTpReducer,
  verifyOtp: verifyOtpReducer,
  createPayment: createPaymentReducer,
  getRecentPayments: getRecentPaymentsReducer,
  getAppointmentAction: getAppointmentReducer,
  getDoctorsAction: getDoctorsReducer,
  getClinicsAction: getClinicsReducer,
  logOutUser: logoutUserReducer,
  checkAppointment: checkAppointment,
  phoneLookup: phoneLookupReducer,
  virtualQrPayment: virtualQrPaymentReducer,
  virtualQrVerify: virtualQrVerifyReducer,
  fetchHospitalPaymentConfig: fetchHospitalPaymentConfigReducer,
  fetchConsultationCosts: fetchConsultationCostsReducer,

});

export default rootReducer;
